import { user_store } from '@/store';

export default async function load_profile() {
  const { id = undefined } = user_store.getters.me_shared;

  if (!id) {
    await user_store.actions.get_user_info();
  }
}
